import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import agendamentosService from '../../api/agendamentosService';
import { Modal, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/auth-context';
import { startConnection, onRecebeNotificacao } from "../../components/notificacao-hub";
import './index.css';
import horariosService from '../../api/horariosService';
import DateSelector from '../../components/data-selector/index';  // Ajuste no nome do componente

const MinhaAgenda = () => {
  const { user } = useAuth();
  const [agendamentos, setAgendamentos] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date()); // Data inicial para seleção

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    startConnection();
    onRecebeNotificacao((nomeProfissional, nomePaciente, hora) => {
      setModalData({ nomeProfissional, nomePaciente, hora });
      fetchAgendamentos(); // Chama a função de busca de agendamentos assim que uma notificação é recebida
    });
  }, []);

  useEffect(() => {
    fetchAgendamentos(); // Recarrega os agendamentos sempre que a data selecionada mudar
  }, [selectedDate, user]);

  const handleNextDay = () => {
    const nextDay = new Date(selectedDate);
    nextDay.setDate(selectedDate.getDate() + 1);
    setSelectedDate(nextDay); // Atualiza a data ao clicar na seta para o próximo dia
  };

  const handlePrevDay = () => {
    const prevDay = new Date(selectedDate);
    prevDay.setDate(selectedDate.getDate() - 1);
    setSelectedDate(prevDay); // Atualiza a data ao clicar na seta para o dia anterior
  };

  // Função que busca os agendamentos com base na data selecionada
  const fetchAgendamentos = async () => {
    setLoading(true);
    setError(null);
    try {
      const dataAtual = format(selectedDate, 'yyyy-MM-dd');
      
      const horariosResponse = await horariosService.listar();
      setHorarios(horariosResponse);
      
      const response = await agendamentosService.listarPorProfissionaleData(dataAtual, user.profissionalId);
      
      if (response) {
        const formattedAgendamentos = response.map(agendamento => ({
          ...agendamento,
          data: agendamento.data ? new Date(agendamento.data) : null,
          horario: agendamento.horario || null
        }));
  
        setAgendamentos(formattedAgendamentos);
      }
    } catch (err) {
      setError('Erro ao buscar agendamentos.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalData(null);
  };

  const getRowClass = (status) => {
    switch (status) {
      case 1: return 'rgba(0, 123, 255, 0.2)';
      case 2: return 'rgba(40, 167, 69, 0.2)';
      case 3: return 'rgba(220, 53, 69, 0.2)';
      default: return '';
    }
  };

  const renderAgenda = () => (
    <table className="custom-table">
      <thead>
        <tr>
          <th className="header-cell">#</th>
          <th className="header-cell">Nome do Paciente</th>
          <th className="header-cell">Status</th>
        </tr>
      </thead>
      <tbody>
        {horarios.map((horarioObj, index) => {
          const horarioStr = horarioObj.horario;
          const agendamento = agendamentos.find((ag) => ag.horario.id === horarioObj.id);
          const status = agendamento ? agendamento.status : null;
          const rowClass = getRowClass(status);

          return (
            <tr key={index} style={{ backgroundColor: rowClass }}>
              <td className="align-middle text-center fw-bold first-column">
                {typeof horarioStr === 'string' && horarioStr.includes(':') ? (
                  parseInt(horarioStr.split(':')[0], 10) + 'h'
                ) : 'N/A'}
              </td>
              <td className="align-middle text-center">
                {agendamento ? (
                  agendamento.paciente ? <b>{agendamento.paciente.nome}</b> : <b>Sublocação</b>
                ) : "Livre"}
              </td>
              <td className="align-middle text-center">
                {agendamento ? (
                  agendamento.descricaoStatus ? <b>{agendamento.descricaoStatus}</b> : <b>Ocupado</b>
                ) : "-"}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <div className="agenda-container">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">Meus Horários</Card.Title>
          <hr />

          <DateSelector 
            selectedDate={selectedDate}
            onDateChange={(date)=> setSelectedDate(date)}  
            onNextDay={handleNextDay}  
            onPrevDay={handlePrevDay}
          />

          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Carregando...</span>
              </Spinner>
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          ) : (
            renderAgenda()
          )}

          <Modal show={showModal} onHide={handleCloseModal}>
            {modalData && (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>{modalData.id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Olá, <strong>{modalData.nomeProfissional}.</strong></p>
                  <p>O paciente <strong>{modalData.nomePaciente.toUpperCase()}</strong> das {String(modalData.hora).padStart(2, '0')}h, acabou de chegar.</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Fechar
                  </Button>
                </Modal.Footer>
              </>
            )}
          </Modal>
        </Card.Body>
      </Card>
    </div>
  );
};

export default MinhaAgenda;
